import { render } from "./maternity_head.vue?vue&type=template&id=a2313cde&scoped=true"
import script from "./maternity_head.vue?vue&type=script&lang=js"
export * from "./maternity_head.vue?vue&type=script&lang=js"

import "./maternity_head.vue?vue&type=style&index=0&id=a2313cde&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2313cde"]])

export default __exports__